export const CUSTOM_EDIT_CONTROL_ID = 'custom-edit-control';
export const CUSTOM_EDIT_CONTROL_MARGIN = 30;
export const EDIT_CONTROL_WIDTH = 73;
export const EDIT_CONTROL_HEIGHT = 41;
